const SYNC_STATUS_TONE = Object.freeze({
  SUCCESS: 'success',
  PARTIAL: 'warning',
  FAILED: 'error',
  QUEUED: 'info',
  STARTED: 'info',
});

/** Return the MUI color used consistently for one EF synchronization status. */
export const syncStatusTone = (status) => SYNC_STATUS_TONE[status] || 'default';
